export const OnCallRouteName = {
  Main: 'on-call',
  Setup: 'setup',
  StandbyLocation: 'standby-location',
  Log: 'log',
  LocationInformation: 'information',
};

export const TripSettingsRouteName = {
  Main: 'trip-settings',
  Expenses: 'expenses',
  ExpensesInformation: 'information',
  FuelPrices: 'fuel-prices',
  FuelPricesInformation: 'information',
  TripTypeSetup: 'trip-type-setup',
  TripTypeSetupInformation: 'information',
  VismaPayroll: 'visma-payroll',
};

export const FleetSettingsRouteName = {
  Main: 'fleet',
  GeofenceLocation: 'geofence-location',
  Information: 'information',
  Map: 'map',
  PredefinedGeofence: 'predefined-geofence',
  PredefinedGeofenceInformation: 'geofence-information',
  PredefinedGeofenceMap: 'map',
};

export const AccessControlSettingsRouteName = {
  Main: 'access-control-settings',
  Roles: 'roles',
  Information: 'information',
  Users: 'users',
  Permissions: 'permissions',
  UserLog: 'user-log',
  PermissionLog: 'permission-log',
};

export const AssetSettingsRouteName = {
  Main: 'assets-settings',
  AssetType: 'asset-type',
  AssetTypeInformation: 'information',
  AssetLocation: 'asset-location',
  AssetLocationInformation: 'information',
  WarehouseTracker: 'warehouse-tracker',
};

export const DepartmentSettingsRouteName = {
  Main: 'department-settings',
  Departments: 'departments',
  Information: 'information',
};

export const AlertSettingsRouteName = {
  Main: 'alerts-settings',
  AlertSetup: 'alert-setup',
  Information: 'information',
  AlertLog: 'alert-log',
};

export const HardwareDevicesSettingsRouteName = {
  Main: 'hardware-devices-settings',
  Trackers: 'trackers',
  TrackersInformation: 'information',
  TrackersLog: 'log',
  FindTags: 'find-tags',
  FindTagsInformation: 'information',
  Keyfobs: 'keyfobs',
  KeyfobsInformation: 'information',
  CardReaders: 'card-readers',
  CardReadersInformation: 'information',
  CardReadersLog: 'log',
};

export const TagSettingsRouteName = {
  Main: 'tag-settings',
  VehicleTags: 'vehicle-tags',
  VehicleTagsInformation: 'information',
  UserTags: 'user-tags',
  UserTagsInformation: 'information',
  VehicleProperties: 'vehicle-properties',
  VehiclePropertiesInformation: 'information',
  UserProperties: 'user-properties',
  UserPropertiesInformation: 'information',
  AssetProperties: 'asset-properties',
  AssetPropertiesInformation: 'information',
};
